import React, { Component } from 'react'

import './sub-header-preview.styl'

import urlFor, { QueryParams } from 'shared/tools/url-helper'
import uiBox, { DecoratorProps } from 'client/shared/decorators/ui-box'

import BackButtonBox from 'client/shared/boxes/back-button-box'

import Logo from 'client/shared/blocks/logo'
import Linka from 'client/shared/blocks/linka'
import TextTruncate from 'client/shared/blocks/text-truncate'

import { MinimalAuthorInfo } from 'client/shared/types/author'

type Props = {
  renderCover: () => Node
  renderButton: () => Node
  visible: boolean
  kind?: string
  previewLink: string
  title?: string
  query?: QueryParams
  authors?: MinimalAuthorInfo[] | string // string comes from the shelf (shelf creator's name or login)
} & DecoratorProps

class SubHeaderPreview extends Component<Props> {
  static defaultProps = {
    renderCover: () => null,
    renderButton: () => null,
    visible: true,
  }

  render(): JSX.Element {
    const {
      previewLink,
      title,
      authors: _authors,
      renderCover,
      renderButton,
      visible,
      kind,
      query,
    } = this.props
    let authors = _authors

    const kindMod = kind ? `sub-header-preview_${kind}` : ``
    if (Array.isArray(authors)) {
      authors = authors.map(author => author.name).join(', ')
    }

    return (
      <div
        className={`sub-header-preview ${
          visible ? 'sub-header-preview_visible' : ''
        } ${kindMod}`}
      >
        <div className="sub-header-preview__logo">
          <Logo href={`${urlFor.root(query)}`} />
        </div>
        <div className="sub-header-preview__wrapper">
          <Linka path={previewLink} className="sub-header-preview__link">
            <div className="sub-header-preview__pic">{renderCover()}</div>
            <div className="sub-header-preview__desc">
              <div className="sub-header-preview__authors">
                {visible && (
                  <TextTruncate lines={1} text={authors} textType="title" />
                )}
              </div>
              <div className="sub-header-preview__title">
                {visible && (
                  <TextTruncate lines={1} text={title} textType="title" />
                )}
              </div>
            </div>
          </Linka>
          <div className="sub-header-preview__button">{renderButton}</div>
        </div>
        <div className="sub-header-preview__back-button">
          {kind === 'full' && <BackButtonBox />}
        </div>
      </div>
    )
  }
}

export default uiBox(SubHeaderPreview)
